import React, { useContext } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { TranslatorContext } from '@jutro/locale';
import { intlMessageShape } from '@jutro/prop-types';
import { getMessageProp } from '@jutro/platform';
import styles from "./Footer.module.css";
import { FooterContext, footerBasicType } from './FooterContext';
import { FooterText } from './FooterText';
import { messages } from './FooterCopyright.messages';
const footerCopyrightPropTypes = {
  className: PropTypes.string,
  messageProps: PropTypes.shape({
    copyrightMessage: intlMessageShape
  })
};
export const FooterCopyright = ({
  className,
  messageProps
}) => {
  const translator = useContext(TranslatorContext);
  const footerType = useContext(FooterContext);
  const classes = cx(styles.footerCopyright, {
    [styles.footerCopyrightBasic]: footerType === footerBasicType
  }, className);
  const copyrightMessage = getMessageProp('copyrightMessage', messageProps, messages);
  const copyrights = translator(copyrightMessage, {
    year: new Date().getFullYear()
  });
  return React.createElement(FooterText, {
    className: classes,
    text: copyrights
  });
};
FooterCopyright.propTypes = footerCopyrightPropTypes;
FooterCopyright.__docgenInfo = {
  componentName: "FooterCopyright",
  packageName: "@jutro/components",
  description: "The `FooterCopyright` component is designed as a simple component presenting copyright inside the `Footer` container.",
  displayName: "FooterCopyright",
  methods: [],
  actualName: "FooterCopyright",
  metadataType: "element",
  props: {
    className: {
      type: {
        name: "string"
      },
      required: false,
      description: "Additional class names for component."
    },
    messageProps: {
      type: {
        name: "shape",
        value: {
          copyrightMessage: {
            name: "union",
            description: "Location aware text of copyright",
            required: false,
            value: [{
              name: "string"
            }, {
              name: "shape",
              value: {
                id: {
                  name: "string",
                  required: false
                },
                defaultMessage: {
                  name: "string",
                  required: false
                },
                args: {
                  name: "shape",
                  value: {},
                  required: false
                }
              }
            }]
          }
        }
      },
      required: false,
      description: "Copyright message props"
    }
  }
};